import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpDataService } from './http-data.service';
import { Game } from 'core/models';

@Injectable()
export class GamesService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/games');
  }

  getGame(id: string): Observable<Game> {
    return super.getItem(id);
  }

  /**
   *  Reset the game data associated to the game data id (i.e. license id)
   *  @param   {string}  gameId      The game id
   *  @param   {string}  gameDataId  The game data id
   *  @return  {Promise}             Reset promise
   */
  resetGame(gameId, gameDataId) {
    return new Promise((resolve, reject) => {
      this.getGame(gameId).subscribe((game) => {
        let url = [game.backendHost, 'resetGame'].join('/');
        if (game.canonicName === 'triskelion_2018') {
          // The new way to reset the game is through the common library games-core (only
          // for Triskelion5 for now, but it should be done for the others when possible).
          url = [game.backendHost, 'games-core', 'resetGame'].join('/');
        }
        const data = { nickname: gameDataId };
        super.postRequest(url, JSON.stringify(data), this.getRequestOptions()).then(resolve).catch(reject);
      });
    });
  }
}
